import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var PerspectiveIcon = function PerspectiveIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "PerspectiveIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.886 2.727a.2.2 0 0 0-.147.033l-.014.014v10.452l.014.014a.2.2 0 0 0 .147.033m0 0 10.286-1.31a.17.17 0 0 0 .103-.048v-7.83l-.005-.005a.17.17 0 0 0-.098-.043L2.886 2.727M1.852 1.614c.347-.269.79-.38 1.217-.326L13.355 2.6c.72.092 1.37.669 1.37 1.476v7.85c0 .807-.65 1.384-1.37 1.476L3.07 14.711a1.66 1.66 0 0 1-1.218-.325 1.46 1.46 0 0 1-.577-1.15V2.764c0-.464.226-.88.577-1.151",
      clipRule: "evenodd"
    })
  }));
};

export { PerspectiveIcon };
